/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/lib%2Fhelpers%2FgetOperatorTitle.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'не равно': {
        ru: 'не\u00A0равно',
        en: 'isn’t equal to',
        'en-IE': 'not equal to',
        tr: 'eşit değil',
        'zh-Hans': '不等于',
    },
    'не содержит': {
        ru: 'не\u00A0содержит',
        en: 'doesn’t contain',
        'en-IE': 'does not contain',
        tr: 'içermiyor',
        'zh-Hans': '不包含',
    },
    равно: {
        ru: 'равно',
        en: 'is\u00A0equal to',
        'en-IE': 'equally',
        tr: 'eşittir',
        'zh-Hans': '等于',
    },
    содержит: {
        ru: 'содержит',
        en: 'contains',
        'en-IE': 'contains',
        tr: 'içeriyor',
        'zh-Hans': '包含',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
